import {
  EditButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const CityShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="heartbeatName" />
    </SimpleShowLayout>
  </Show>
);
